import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getAppUsersRequest = () => ({
  type: 'GET_APP_USERS_REQUEST',
})

export const getAppUsersSuccess = (users) => ({
  type: 'GET_APP_USERS_SUCCESS',
  users,
})

export const getAppUsersFailure = (error) => ({
  type: 'GET_APP_USERS_FAILURE',
  error,
})

export const getSingleAppUserRequest = () => ({
  type: 'GET_SINGLE_APP_USER_REQUEST',
})

export const getSingleAppUserSuccess = (user) => ({
  type: 'GET_SINGLE_APP_USER_SUCCESS',
  user,
})

export const getSingleAppUserFailure = (error) => ({
  type: 'GET_SINGLE_APP_USER_FAILURE',
  error,
})

export const deleteAppUserRequest = () => ({
  type: 'DELETE_APP_USER_REQUEST',
})

export const deleteAppUserSuccess = () => ({
  type: 'DELETE_APP_USER_SUCCESS',
})

export const deleteAppUserFailure = (error) => ({
  type: 'DELETE_APP_USER_FAILURE',
  error,
})

export const getAppUsers = () => {
  return (dispatch) => {
    dispatch(getAppUsersRequest())

    fetch(URL.BASE_URL + URL.END_POINT.appusers, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((users) => {
        dispatch(getAppUsersSuccess(users))
      })
      .catch((error) => {
        dispatch(getAppUsersFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

export const getSingleAppUser = (id) => {
  return (dispatch) => {
    dispatch(getSingleAppUserRequest())

    fetch(URL.BASE_URL + URL.END_POINT.appusers + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((user) => {
        dispatch(getSingleAppUserSuccess(user))
      })
      .catch((error) => {
        dispatch(getSingleAppUserFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

export const deleteAppUser = (id) => {
  return (dispatch) => {
    dispatch(deleteAppUserRequest())

    fetch(URL.BASE_URL + URL.END_POINT.appusers + 'delete-account/' + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(deleteAppUserSuccess())
        toast('User deleted successfully', { type: 'success' })
      })
      .catch((error) => {
        dispatch(deleteAppUserFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

const initialAppState = {
  appUsers: [],
  loadingAppUsers: false,
  errorAppUsers: null,
}

export const appReducer = (state = initialAppState, action) => {
  switch (action.type) {
    case 'GET_APP_USERS_REQUEST':
      return {
        ...state,
        loadingAppUsers: true,
        errorAppUsers: null,
      }
    case 'GET_APP_USERS_SUCCESS':
      return {
        ...state,
        appUsers: action.users,
        loadingAppUsers: false,
        errorAppUsers: null,
      }
    case 'GET_APP_USERS_FAILURE':
      return {
        ...state,
        loadingAppUsers: false,
        errorAppUsers: action.error,
      }
    default:
      return state
  }
}

const initialAppUserState = {
  singleAppUser: null,
  loadingSingleAppUser: false,
  errorSingleAppUser: null,
}

export const appUserReducer = (state = initialAppUserState, action) => {
  switch (action.type) {
    case 'GET_SINGLE_APP_USER_REQUEST':
      return {
        ...state,
        loadingSingleAppUser: true,
        errorSingleAppUser: null,
      }
    case 'GET_SINGLE_APP_USER_SUCCESS':
      return {
        ...state,
        singleAppUser: action.user.app_user,
        loadingSingleAppUser: false,
        errorSingleAppUser: null,
      }
    case 'GET_SINGLE_APP_USER_FAILURE':
      return {
        ...state,
        loadingSingleAppUser: false,
        errorSingleAppUser: action.error,
      }
    default:
      return state
  }
}
